export default __webpack_public_path__ + "static/media/profile-settings.432e06bc.svg";